import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { CONTACT } from "../data";
import { Reveal } from "./Reveal";

export const CTABand = () => (
  <section className="bg-primary">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-20 sm:py-28 text-center">
      <Reveal>
        <h2 className="text-white text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-snug">
          Get tech help today
        </h2>
        <p className="mt-5 text-slate-300 text-lg md:text-xl max-w-2xl mx-auto leading-relaxed">
          Friendly, judgement‑free support is just one call away. Let's make your
          technology work for you.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href={CONTACT.phoneHref}
            data-testid="cta-band-call"
            className="inline-flex items-center justify-center gap-2 h-14 px-8 rounded-full bg-accent text-white font-bold text-lg hover:bg-[hsl(196,82%,27%)] transition-colors"
          >
            <Phone className="h-5 w-5" /> Call {CONTACT.phone}
          </a>
          <Link
            to="/contact"
            data-testid="cta-band-book"
            className="inline-flex items-center justify-center h-14 px-8 rounded-full bg-white text-[hsl(213,40%,10%)] font-bold text-lg hover:bg-slate-200 transition-colors"
          >
            Book an Appointment
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);
